module.exports = __webpack_public_path__ + "static/media/S3N11-6.8722136d.svg";